// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
import SettingsIcon from "@material-ui/icons/Settings";
import PeopleIcon from "@material-ui/icons/People";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import DepartureBoardIcon from "@material-ui/icons/DepartureBoard";
import ErrorIcon from "@material-ui/icons/Error";
import NotesIcon from "@material-ui/icons/Notes";
import TimelineIcon from "@material-ui/icons/Timeline";
import BuildIcon from "@material-ui/icons/Build";
// core components/views
import DashboardPage from "../views/Dashboard/Dashboard.jsx";
import AdminDashboardPage from "../views/Dashboard/adminDashboard.jsx";
import CustomerDashboard from "../customers/customerboardroutes";
import UserProfileRoutes from "../customers/profile/routes";
import InspectionRoutes from "../views/Inspections/InspectionRoutes.js";
import FleetRoutes from "../views/Company/FleetRoutes.js";
import Settings from "../customers/settings";
import TireVendor from "../customers/TireVendor/TireVendors";
import Vendors from "../customers/Vendor/Vendors";
import Inspectors from "../customers/Inspector/Inspectors";
import VendorProfileRoutes from "../vendors/profile/routes";
import InspectorRoutes from "../Inspector/InspectorRoutes";
import AdminInspectorRoutes from "../admin/AdminInspectorRoutes";
import NotificationsPage from "../views/Notifications/Notifications.jsx";
import DefectsMngt from "../views/Defects/Defects";
import mySignOut from "../auth/signOut";
import AdminVehicleRoutes from "../admin/vehicle/adminVehiclesRoutes";
import CustomerRoutes from "../admin/customer/CustomerRoutes";
import AdminInspection from "../admin/adminDashboard/admindashboardroutes";
import settings from "../customers/settings";
import DashboardRoutes from "../customers/DashboardRoutes";
import DefectRoute from "../views/Defects/defectRoute";
import MobileUserDashboard from "../customers/mobileusers_dashboard";
import DispatcherDashboard from "../customers/dispatchers/dashboard";
import InspectionPage from "../inspection/inspetionsPage";
import InspectionsRoute from "../inspection/inspectionRoutes";
import VendorDashboard from "../views/Dashboard/VendorDashboard.js";
import VendorRoutes from "../vendors/VendorRoutes.js";
import MechanicRoutes from "../vendors/MechanicRoutes";
import UserManagement from "../admin/UserManagement.js";
export const dashboardRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Dashboard",
    icon: Dashboard,
    component: DashboardRoutes
  },
  {
    path: "/company",
    sidebarName: "Vehicles",
    navbarName: "Vehicles",
    icon: LocalShippingIcon,
    component: FleetRoutes
  },
  {
    path: "/Inspection",
    sidebarName: "Inspections",
    navbarName: "Inspections",
    icon: DepartureBoardIcon,
    component: CustomerDashboard
  },
  {
    path: "/defects",
    sidebarName: "Work Orders",
    navbarName: "Work Orders",
    icon: ErrorIcon,
    component: DefectRoute
  },
  {
    path: "/profile",
    sidebarName: "Team Setup",
    navbarName: "Team Setup",
    icon: PeopleIcon,
    component: UserProfileRoutes
  },
  {
    path: "/tirevendor",
    sidebarName: "Tire Mans",
    navbarName: "Tire Mans",
    icon: Notifications,
    component: TireVendor
  },
  {
    path: "/vendor",
    sidebarName: "Outside Mechanics",
    navbarName: "Outside Mechanics",
    icon: BuildIcon,
    component: Vendors
  },
  {
    path: "/inspectors",
    sidebarName: "Outside Inspectors",
    navbarName: "Outside Inspectors",
    icon: BuildIcon,
    component: Inspectors
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];
export const dispatcherRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Dashboard",
    icon: Dashboard,
    component: DashboardRoutes
  },
  {
    path: "/company",
    sidebarName: "Vehicles",
    navbarName: "Vehicles",
    icon: LocalShippingIcon,
    component: FleetRoutes
  },
  {
    path: "/inspection/new/otf",
    sidebarName: "On the Fly|Report a Defect",
    navbarName: "Report On The Fly Defect(s)",
    icon: ErrorIcon,
    component: CustomerDashboard
  },
  {
    path: "/Inspection",
    sidebarName: "Inspections",
    navbarName: "Inspections",
    icon: DepartureBoardIcon,
    component: CustomerDashboard
  },
  {
    path: "/defects",
    sidebarName: "Work Orders",
    navbarName: "Work Orders",
    icon: ErrorIcon,
    component: DefectRoute
  },
  {
    path: "/profile",
    sidebarName: "Team Setup",
    navbarName: "Team Setup",
    icon: PeopleIcon,
    component: UserProfileRoutes
  },
  {
    path: "/tirevendor",
    sidebarName: "Tire Mans",
    navbarName: "Tire Mans",
    icon: Notifications,
    component: TireVendor
  },
  {
    path: "/vendor",
    sidebarName: "Outside Mechanics",
    navbarName: "Outside Mechanics",
    icon: BuildIcon,
    component: Vendors
  },
  {
    path: "/inspectors",
    sidebarName: "Outside Inspectors",
    navbarName: "Outside Inspectors",
    icon: BuildIcon,
    component: Inspectors
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];
export const technicianRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Dashboard",
    icon: Dashboard,
    component: DashboardRoutes
  },
  {
    path: "/inspection/new/insp",
    sidebarName: "New Inspection",
    navbarName: "New Inspection",
    icon: DepartureBoardIcon,
    component: CustomerDashboard
  },
  {
    path: "/inspection/new/otf",
    sidebarName: "On the Fly|Report a Defect",
    navbarName: "Report On The Fly Defect(s)",
    icon: ErrorIcon,
    component: CustomerDashboard
  },
  {
    path: "/company",
    sidebarName: "Vehicles",
    navbarName: "Vehicles",
    icon: LocalShippingIcon,
    component: FleetRoutes
  },

  {
    path: "/Inspection",
    sidebarName: "Inspections",
    navbarName: "Inspections",
    icon: DepartureBoardIcon,
    component: CustomerDashboard
  },
  {
    path: "/defects",
    sidebarName: "Work Orders",
    navbarName: "Work Orders",
    icon: ErrorIcon,
    component: DefectRoute
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];
export const inspectorRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Inspector Dashboard",
    icon: Dashboard,
    component: DashboardPage
  },
  {
    path: "/user",
    sidebarName: "Profile",
    navbarName: "Profile",
    icon: Person,
    component: InspectorRoutes
  },
  {
    path: "/Inspection",
    sidebarName: "Inspections",
    navbarName: "Inspections",
    icon: Dashboard,
    component: AdminInspection
  },
  {
    path: "/signOut",
    sidebarName: "Sign Out",
    navbarName: "SignOut",
    icon: Notifications,
    component: mySignOut
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];

export const mechanicRoutes = [
  {
    path: "/mech",
    sidebarName: "Dashboard",
    navbarName: "Dashboard",
    icon: Dashboard,
    component: MechanicRoutes
  },
  {
    path: "/signOut",
    sidebarName: "Sign Out",
    navbarName: "SignOut",
    icon: Notifications,
    component: mySignOut
  },
  { redirect: true, path: "/", to: "/mech", navbarName: "Redirect" }
];

export const vendorRoutes = [
  {
    path: "/vendor",
    sidebarName: "Dashboard",
    navbarName: "Vendor Dashboard",
    icon: Dashboard,
    component: VendorRoutes
    // component: DashboardPage
  },
  {
    path: "/profile",
    sidebarName: "Profile",
    navbarName: "Profile",
    icon: Person,
    component: VendorProfileRoutes
  },
  {
    path: "/signOut",
    sidebarName: "Sign Out",
    navbarName: "SignOut",
    icon: Notifications,
    component: mySignOut
  },
  { redirect: true, path: "/", to: "/vendor", navbarName: "Redirect" }
];
export const tireVendorRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Tire Vendor Dashboard",
    icon: Dashboard,
    component: DashboardPage
  },
  {
    path: "/profile",
    sidebarName: "Profile",
    navbarName: "Profile",
    icon: Person,
    component: VendorProfileRoutes
  },
  {
    path: "/signOut",
    sidebarName: "Sign Out",
    navbarName: "SignOut",
    icon: Notifications,
    component: mySignOut
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];
export const adminRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Admin Dashboard",
    icon: Dashboard,
    component: AdminDashboardPage
  },
  {
    path: "/customer",
    sidebarName: "Customer",
    navbarName: "Customer Vehicles",
    icon: Dashboard,
    component: CustomerRoutes
  },
  {
    path: "/Inspection",
    sidebarName: "Admin Inspection",
    navbarName: "Admin Inspection",
    icon: Dashboard,
    component: AdminInspection
  },
  {
    path: "/vehicle",
    sidebarName: "Vehicles Types",
    navbarName: "Vehicles Types",
    icon: Dashboard,
    component: AdminVehicleRoutes
  },
  {
    path: "/inspector",
    sidebarName: "Inspectors",
    navbarName: "Inspectors Profiles",
    icon: Person,
    component: AdminInspectorRoutes
  },
  {
    path: "/users",
    sidebarName: "Users",
    navbarName: "Users Profiles",
    icon: Person,
    component: UserManagement
  },
  {
    path: "/signOut",
    sidebarName: "Sign Out",
    navbarName: "SignOut",
    icon: Notifications,
    component: mySignOut
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];
export const mobileUserRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Home",
    navbarName: "Home",
    icon: Dashboard,
    component: MobileUserDashboard
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];
export const dispatcherUserRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Home",
    navbarName: "Home",
    icon: Dashboard,
    component: DispatcherDashboard
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx